import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';
export const styles = StyleSheet.create({
  container: {
    paddingTop: 36,
    paddingHorizontal: 16,
    gap: 24,
    flexGrow: 1,
    backgroundColor: themes.light.white[1],
  },
  topContainer: {
    width: '100%',
    flex: 1,
    gap: 24,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between', // Space between buttons
    gap: 8,
    width: '100%',
    paddingVertical: 12,
  },
  buttonWrapper1: {
    flex: 1, // Allow it to grow
    maxWidth: '33%', // Restrict to 33% width
  },
  buttonWrapper2: {
    flex: 1, // Allow it to grow
    maxWidth: '67%', // Restrict to 67% width
  },
  selectionContainer: {
    marginTop: 20,
    alignItems: 'flex-start',
  },
  selectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
  },
});
